//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapState} from 'vuex';

export default {
  name: "MyElBreadcrumb",
  inject: ["reload"],
  data() {
    return {
      breadList: [] // 路由集合
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
  },
  methods: {
    jumpUrl(item) {
      const route = {path: item}
      if (this.$route.query.currentPage) {
        Object.assign(route, {query: {currentPage: this.$route.query.currentPage}})
      }
      if (this.$route.query.secondPage) {
        Object.assign(route.query, {secondPage: this.$route.query.secondPage})
      }
      this.$router.push(route);
      this.reload();
    },
    getBreadcrumb() {
      var array = [];
      var item = {};
      // 获取title 和 path存入缓存
      array = JSON.parse(window.sessionStorage.getItem("breadList"));
      item.path = window.location.href.split('#')[1];
      item.title = this.$route.meta.title;
      if (array === null) {
        array = [];
      }

      // 存在二级以上时防止重复
      const itemIndex = array.findIndex(e => e.title === item.title);
      if (itemIndex > -1) {
        array.splice(itemIndex + 1, array.length - itemIndex + 1)
      } else {
        array.push(item);
      }

      // 首页清空
      if (item.title === '首页') {
        array = [];
      } else if (item.title === '资源管理' || item.title === '习题组卷'
        || item.title === '成绩管理' || item.title === '统计分析' || item.title === '使用分析' || item.title === '试题库' || item.title === '试卷库'
        || item.title === '课程管理' || item.title === '班级管理' || item.title === '专业管理' || item.title === '试卷类型管理'
        || item.title === '学校管理' || item.title === '基础课程管理' || item.title === '专业课程管理' || item.title === 'Banner管理'
        || item.title === '考证管理' || item.title === 'Banner推送管理' || item.title === '个人管理'|| item.title==='大连学业水平质量抽测填报'|| item.title==='大连中等职业学校学业质量测试') {
        // 数组只有一个元素 清空数组
        array = [];
        // todo:push 首页
        var home = {};
        home.title = '首页';
        if (this.userInfo.role.roleCode == "appadmin") {
          home.path = '/homePage';
        } else {
          home.path = '/moduleOption';
        }
        array.push(home);
        array.push(item);
      }
      var i = 0;
      var index = 0;
      // 第二次进入清空之后的数据
      var count = 0;
      array.forEach(a => {
        if (a.path === item.path) {
          if (count < 1) {
            count++;
            index = i;
          } else {
            array = array.slice(0, index + 1);
          }
        }
        i++;
      });

      this.breadList = array;
      window.sessionStorage.setItem("breadList", JSON.stringify(array));
    }
  },
  created() {
    this.getBreadcrumb();
  }
};



// WEBPACK FOOTER //
// ./src/components/common/ExamBreadcrumb.vue